import { moduleCache } from "./async";

export const useAsyncModules : UseAsyncModules = ( modules ) => {
    return modules.map<any>( module => moduleCache.get(module) );
}